"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPaymentAccount = void 0;
/**
 * Formats a PaymentAccount object into a string representation, incorporating localization.
 * - If the 'name' field in the paymentAccount object is empty, it defaults to a generic account name from the 'language' object.
 * - The formatted string includes the last four digits of the account number, masked with '••••'.
 * - This approach is useful for displaying payment account information in a user-friendly manner while maintaining partial confidentiality of the account number.
 *
 * @param paymentAccount - The PaymentAccount object containing the account's details.
 * @param language - An object containing localization details, used to provide a generic account name.
 * @returns The formatted string representation of the PaymentAccount.
 */
const formatPaymentAccount = (paymentAccount, language) => {
    if (!paymentAccount)
        return "";
    const { name, accountNumberLast4 } = paymentAccount;
    const validatedName = name !== null && name !== void 0 ? name : "";
    const validatedAccountNumberLast4 = accountNumberLast4 !== null && accountNumberLast4 !== void 0 ? accountNumberLast4 : "";
    if (!validatedAccountNumberLast4) {
        return "";
    }
    return validatedName === ""
        ? `${language.account} (•••• ${validatedAccountNumberLast4})`
        : `${validatedName} (•••• ${validatedAccountNumberLast4})`;
};
exports.formatPaymentAccount = formatPaymentAccount;
